module.exports = __webpack_public_path__ + "img/none.63ec4f8e.png";